<template>
  <transition name="no-mode-fade">
    <div
      id="home"
      class="tab-pane fade show active"
      role="tabpanel"
      aria-labelledby="home-tab"
    >
      <div class="row mb-3 mt-3">
        <div class="col-md-3">
          <b-button-group>
            <b-button variant="outline-warning"
              ><input
                v-model="selectAll"
                type="checkbox"
                @change="selectItemAll(selectAll)"
            /></b-button>

            <b-dropdown :text="chooseAction" variant="outline-warning">
              <b-dropdown-item
                :disabled="recordIds.length == 0"
                @click="assignMultiStudents"
              >
                {{ $t("badges.assign_students") }}
              </b-dropdown-item>
              <b-dropdown-item
                :disabled="recordIds.length == 0"
                @click="unAssignMultiStudent()"
              >
                {{ $t("badges.unassign_students") }}
              </b-dropdown-item>
            </b-dropdown>
          </b-button-group>
          <!-- end of form -->
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <input
              v-model="search"
              type="text"
              autofocus
              class="form-control"
              :placeholder="$t(`site.search`)"
              @input="(val) => searchChange(val)"
            />
          </div>
        </div>

        <div class="col-3">
          <div class="float-md-right pt-1">
            <span class="text-muted text-small mr-1 mb-2"
              >{{ from }}:{{ to }}
            </span>

            <b-dropdown
              id="ddown2"
              right
              :text="`${perPage}`"
              variant="outline-warning"
              size="xs"
            >
              <b-dropdown-item
                v-for="(size, index) in [5, 10, 20, 50, 100]"
                :key="index"
                @click="changePageSize(size)"
                >{{ size }}</b-dropdown-item
              >
            </b-dropdown>
            <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
          </div>
        </div>
        <!-- end of col -->
      </div>
      <!-- end of row -->

      <div class="row mt-5">
        <div class="col-md-12">
          <b-table :stacked="($mobile==1)" 
            ref="table"
            class="vuetable"
            sort-by="id"
            sort-desc.sync="false"
            :current-page="currentPage"
            :fields="bootstrapTable.fields"
            :items="dataProvider"
          >
            <!-- <template #cell(edit)='data'>
            <button
            class='btn btn-icon btn-warning btn-sm'
            @click='editItem(data)'
            >
            <i class='fa fa-edit'></i>
            </button>
            <button
            type='submit'
            class='btn btn-icon btn-danger btn-sm delete'
            @click='deleteItem(data)'
            >
            <i class='fa fa-trash'></i>
            </button>
        </template> -->

            <!-- checkbox -->
            <template #cell(checkbox)="data">
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">
                <input
                  v-model="recordIds"
                  type="checkbox"
                  :value="data.item.id"
                  @change="selectItem(data)"
                />
                <span />
              </label>
            </template>

            <template #cell(assign)="data">
              <a
                v-if="assigned(data)"
                class="btn btn-primary btn-sm"
                @click="assignStudent(data.item.id)"
                ><i class="fa fa-plus" /> {{ $t("badges.assign_student") }}
              </a>
              <a
                v-else
                class="btn btn-danger btn-sm"
                @click="unAssignStudent(data.item.id)"
                ><i class="fa fa-trash" /> {{ $t("badges.unassign_student") }}
              </a>
            </template>
          </b-table>
          <div v-if="load" class="lds-ripple-bk justify-content-center">
            <div />
            <div />
          </div>

          <hr />

          <b-pagination
            v-model="currentPage"
            align="right"
            class="dataTables_paginate paging_simple_numbers pagination-warning"
            :total-rows="totalRows"
            :per-page="perPage"
          >
            <template v-slot:next-text>
              <i class="fas fa-angle-left" />
            </template>
            <template v-slot:prev-text>
              <i class="fas fa-angle-right" />
            </template>
            <template v-slot:first-text>
              <i class="fas fa-step-forward" />
            </template>
            <template v-slot:last-text>
              <i class="fas fa-step-backward" />
            </template>
          </b-pagination>

          <!-- end of table -->
        </div>
        <!-- end of col -->
      </div>
      <!-- end of row -->
    </div>
  </transition>
</template>

<script>
import controller from "../../../../Controllers/BadgesController";
import config from "../../../../config/config";
import UsersController from "@/Controllers/UsersController";

const ctr = new controller();
export default {
  props: ["items", "editItem"],
  data() {
    return {
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          { key: "checkbox", label: "", sortable: false },
          {
            key: "code",
            label: this.$i18n.t("students.academic_number"),
            sortable: true,
          },
          {
            key: "full_name",
            label: this.$i18n.t("badges.name"),
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "email",
            label: this.$i18n.t("users.email"),
            sortable: true,
            sortDirection: "desc",
          },

          {
            key: "assign",
            label: this.$t("badges.signn_unsighn"),
            sortable: false,
          },
        ],
      },
      data: {},
      selectAll: false,
      
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
    };
  },
  computed: {
    chooseAction() {
      return this.$t("badges.signn_unsighn");
    },
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },

    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },

    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await new UsersController().GetAll(
        this.apiParamsConverter()
      );
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;

      this.load = false;
      return data.data;
    },

    apiParamsConverter() {
      const apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }
      apiParams.type = "student";
      apiParams.with = ["badges"];
      return apiParams;
    },

    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },

    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },

    selectItemAll(select) {
      this.recordIds = [];

      if (select) {
        console.log("this data", this.data);
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },

    deleteItem(data) {
      ctr.Delete(data.item.id, this.$refs.table);
    },

    multiDelete() {
      ctr.Delete(0, this.recordIds, this.$refs.table);
    },

    assignMultiStudents() {
      ctr.badgeToStudents(this.recordIds, this.$route.params.badgeId);
      this.$refs.table.refresh();
      this.recordIds = [];
    },

    assignStudent(id) {
      ctr.badgeToStudents(id, this.$route.params.badgeId);
      this.$refs.table.refresh();
      this.recordIds = [];
    },

    unAssignStudent(id) {
      ctr.badgeToStudents(id, this.$route.params.badgeId, "remove");
      this.$refs.table.refresh();
      this.recordIds = [];
    },

    unAssignMultiStudent() {
      ctr.badgeToStudents(this.recordIds, this.$route.params.badgeId, "remove");
      this.$refs.table.refresh();
      this.recordIds = [];
    },

    assigned(data) {
      const index = data.item.badges.findIndex(
        (a) => a.id == this.$route.params.badgeId
      );
      if (index !== -1) return false;
      return true;
    },
  },
};
</script>
